export default __webpack_public_path__ + "static/media/icon-call.e946d8a6.svg";